import React from 'react';

import { DomainDetail } from 'components/blocks/Domain';


const DetailScreen = (props) => {
  return (
    <DomainDetail/>
  )
};

export default DetailScreen;
